export class WebAudioContext {
    constructor() {
        this.context = null;
    }
    ensureContext() {
        if (!this.context) {
            this.context = new (window.AudioContext || window.webkitAudioContext)();
        }
        return this.context;
    }
    async playSound(buffer, volume = 1.0) {
        const ctx = this.ensureContext();
        const audioBuffer = await ctx.decodeAudioData(buffer);
        const source = ctx.createBufferSource();
        const gainNode = ctx.createGain();
        source.buffer = audioBuffer;
        gainNode.gain.value = volume;
        source.connect(gainNode);
        gainNode.connect(ctx.destination);
        source.start(0);
    }
}
